import styled from "styled-components";
import { Container } from "styles/common/container";
import { breakpoints } from "styles/constants/breakpoints";

export const Wrapper = styled(Container)`
  background: ${({ theme }) => theme.colors.white};
  padding: 80px 100px;
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  @media ${breakpoints.mobile} {
    flex-direction: column;
    gap: 26px;
    padding: 40px 20px;
  }
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding: 0 16px;
  position: relative;
  width: 380px;
  @media ${breakpoints.mobile} {
    gap: 16px;
    width: 350px;
    padding: 0;
    align-items: center;
  }
`;

export const Title = styled.h2`
  position: relative;
  font-family: ${({ theme }) => theme.fonts.primary};
  line-height: 46px;
  font-size: ${({ theme }) => theme.fontSizes["3xl"]};
  text-align: left;
  width: 400px;
  @media ${breakpoints.mobile} {
    font-size: ${({ theme }) => theme.fontSizes["xl"]};
    line-height: 32px;
    text-align: center;
    width: 350px;
    text-wrap: pretty;
    margin: 0;
  }
`;

export const RegisterCTA = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  gap: 8px;
  height: 24px;
  width: fit-content;
  cursor: pointer;
  font-weight: bold;
  padding: 12px 24px;
  text-decoration: none;
  font-family: ${({ theme }) => theme.fonts.primary};
  background-color: ${({ theme }) => theme.colors.blue[100]};
  color: ${({ theme }) => theme.colors.brand[500]};
`;

export const CardsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding: 0 16px;
  position: relative;
  width: 750px;
  @media ${breakpoints.mobile} {
    width: 100%;
    padding: 0 10px;
  }
`;

export const CardSection = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 32px;
  padding: 0 16px;
  position: relative;
  width: 100%;
  @media ${breakpoints.mobile} {
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
    width: 100%;
    padding: 0;
  }
`;

export const Card = styled.div`
  display: flex;
  flex-direction: row;
  gap: 24px;
  padding: 24px;
  position: relative;
  width: 300px;
  max-height: 100px;
  align-items: center;
  border-radius: 8px;
  box-shadow: 0px 0px 32px 0px #72839e29;
  @media ${breakpoints.mobile} {
    flex-direction: column;
    gap: 16px;
    padding: 16px;
    width: auto;
    max-height: 100%;
    align-items: start;
  }
`;

export const ImgWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  @media ${breakpoints.mobile} {
    text-align: left;
  }
`;

export const CardTitle = styled.h2`
  font-family: ${({ theme }) => theme.fonts.primary};
  line-height: 32px;
  font-size: ${({ theme }) => theme.fontSizes["xl"]};
  font-weight: 700;
  text-align: left;
  max-width: 200px;
  text-wrap: pretty;
  @media ${breakpoints.mobile} {
    font-size: ${({ theme }) => theme.fontSizes["md"]};
    text-align: left;
    line-height: 24px;
  }
`;
export const Toggle = styled.div`
  display: block;

  @media ${breakpoints.mobile} {
    display: none;
  }
`;
export const Toggle2 = styled.div`
  display: none;
  @media ${breakpoints.mobile} {
    display: block;
    transform: translateX(12%);
  }
`;
